import { render } from "./wallet.vue?vue&type=template&id=e318259c&scoped=true"
import script from "./wallet.vue?vue&type=script&lang=js"
export * from "./wallet.vue?vue&type=script&lang=js"

import "./wallet.vue?vue&type=style&index=0&id=e318259c&scoped=true&lang=css"
import "./wallet.vue?vue&type=style&index=1&id=e318259c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e318259c"]])

export default __exports__